import { ApiBase } from '@fg-services/api/models/api-base';

export class SquareIntegrationApi extends ApiBase {
  model = 'SquareIntegrations';

  connect(params: { id: string; squareAccountId: string }) {
    return this.http.put<void>(this.modelBase, params);
  }
}
